
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import EchangeForm from '@/components/forms/EchangeForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const echangeModule = namespace('echange')

@Component({
  components: {
    BaseCardContainer,
    EchangeForm
  }
})
export default class ProspectContactCreate extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @echangeModule.Action('createEchangeAction') createEchange: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createEchange(data).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectEchange', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.replace({name: 'prospectEchange', params: {id: this.$route.params.id}})
  }
}
